import { useSelector } from 'react-redux';

import {
  selectAIRecommendation,
  selectIsBlockerLauncherShown,
  selectIsRedirectToAILauncher,
  selectPageScrollValue,
  selectProductInteraction,
  selectTasteMatchProductId,
  selectWidgetIframeParentDimension,
} from '@lib/core/service/selectors/widgetInstance';
import {
  resetAIRecommendation,
  resetProductInteraction,
  setAIRecommendation,
  setIsBlockerLauncherShown,
  setIsRedirectToAILauncher,
  setPageScrollValue,
  setProductInteraction,
} from '@lib/core/service/slices/widgetInstanceSlice';
import { TAIRecommendation, TSetProductInteraction } from '@lib/core/service/types/interface';
import { useTypedDispatch } from '@lib/tools/views/hooks/useTypedDispatch';

export const useWidgetInstance = () => {
  const dispatch = useTypedDispatch();

  return {
    aiRecommendation: useSelector(selectAIRecommendation),
    handleResetAIRecommendation: () => dispatch(resetAIRecommendation()),
    handleResetPageScroll: () => dispatch(setPageScrollValue({ scrollAction: '' })),
    handleResetProductInteraction: () => dispatch(resetProductInteraction()),
    handleSetAIRecommendation: (args: TAIRecommendation) => dispatch(setAIRecommendation(args)),
    handleSetIsBlockerLauncherShown: (isBlockerLauncherShown: boolean) =>
      dispatch(setIsBlockerLauncherShown(isBlockerLauncherShown)),
    handleSetIsRedirectToAILauncher: (isRedirectToAILauncher: boolean) =>
      dispatch(setIsRedirectToAILauncher(isRedirectToAILauncher)),
    handleSetProductInteraction: (args: TSetProductInteraction) => dispatch(setProductInteraction({ ...args })),
    isBlockerLauncherShown: useSelector(selectIsBlockerLauncherShown),
    isRedirectToAILauncher: useSelector(selectIsRedirectToAILauncher),
    pageScrollValue: useSelector(selectPageScrollValue),
    productInteraction: useSelector(selectProductInteraction),
    tasteMatchProductId: useSelector(selectTasteMatchProductId),
    widgetIframeParentDimension: useSelector(selectWidgetIframeParentDimension),
  };
};
